import apiClient from './apiClient';

const normalizeSymbolForUrl = (symbol) => symbol?.replace('/', '-') || '';

export const customEventSymbolApi = {
  activateEvent: async (eventId, symbol, config = {}) => {
    const response = await apiClient.post('/custom-event-symbols', {
      eventId,
      symbol,
      config
    });
    return response.data;
  },

  deactivateEvent: async (eventId, symbol) => {
    const response = await apiClient.put(`/custom-event-symbols/${eventId}/${normalizeSymbolForUrl(symbol)}/deactivate`);
    return response.data;
  },

  updateConfig: async (eventId, symbol, config) => {
    const response = await apiClient.put(`/custom-event-symbols/${eventId}/${normalizeSymbolForUrl(symbol)}/config`, {
      config
    });
    return response.data;
  },

  getUserAssociations: async (activeOnly = false) => {
    const params = activeOnly ? '?activeOnly=true' : '';
    const response = await apiClient.get(`/custom-event-symbols${params}`);
    return response.data;
  },

  getSymbolsForEvent: async (eventId) => {
    const response = await apiClient.get(`/custom-event-symbols/event/${eventId}`);
    return response.data;
  },

  getEventsForSymbol: async (symbol) => {
    const response = await apiClient.get(`/custom-event-symbols/symbol/${normalizeSymbolForUrl(symbol)}`);
    return response.data;
  },

  getAssociation: async (eventId, symbol) => {
    const response = await apiClient.get(`/custom-event-symbols/${eventId}/${normalizeSymbolForUrl(symbol)}`);
    return response.data;
  },

  deleteAssociation: async (eventId, symbol) => {
    const response = await apiClient.delete(`/custom-event-symbols/${eventId}/${normalizeSymbolForUrl(symbol)}`);
    return response.data;
  },

  enableAllForEvent: async (eventId, symbols, defaultConfig = {}) => {
    const response = await apiClient.post(`/custom-event-symbols/${eventId}/enable-all`, {
      symbols,
      defaultConfig,
    });
    return response.data;
  },

  disableAllForEvent: async (eventId, symbols) => {
    const response = await apiClient.post(`/custom-event-symbols/${eventId}/disable-all`, {
      symbols,
    });
    return response.data;
  }
};

export default customEventSymbolApi;
